var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 5.33398H6.66732C5.93094 5.33398 5.33398 5.93094 5.33398 6.66732V12.0007C5.33398 12.737 5.93094 13.334 6.66732 13.334H12.0007C12.737 13.334 13.334 12.737 13.334 12.0007V6.66732C13.334 5.93094 12.737 5.33398 12.0007 5.33398Z",
    stroke: "#353535",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.666 5.33268V3.99935C10.666 3.64573 10.5255 3.30659 10.2755 3.05654C10.0254 2.80649 9.6863 2.66602 9.33268 2.66602H3.99935C3.64573 2.66602 3.30659 2.80649 3.05654 3.05654C2.80649 3.30659 2.66602 3.64573 2.66602 3.99935V9.33268C2.66602 9.6863 2.80649 10.0254 3.05654 10.2755C3.30659 10.5255 3.64573 10.666 3.99935 10.666H5.33268",
    stroke: "#353535",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.98fb37e709d513fa5e9af3d91922c2b6.svg";
export { ForwardRef as ReactComponent };